module.exports = __webpack_public_path__ + "img/default-cover.15a09af7.svg";